<template>
  <v-app class="us-v-app">
    <v-app-bar color="blue-grey" dense dark app>
      <v-btn icon @click="goBack">
        <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title style="font-size:1rem;">修改团队名称</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="success" @click="goSave">保存</v-btn>
    </v-app-bar>
    <v-content>
      <v-container>
          <div style="width:95%;margin:auto;">
            <v-text-field v-model="val" counter="50"></v-text-field>
          </div>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  components: {},
  props: {
  },
  data() {
    return {
      val: '',
      title: ''
    }
  },
  computed: {
  },
  mounted() {
  },
  created() {
    var that = this
    that.title = that.$route.query.title
    that.val = that.$route.query.val
  },
  methods: {
    goBack() {
      this.$router.goBack()
    },
    goSave() {
      var that = this
      if (!that.val) {
        return
      }
      if (that.val.length > 50) {
        that.$toast.warning('团队名称长度不能超过50')
        return
      }
      var code = that.$route.query.code
      that.$api.bz.alterCompanyName({ company_code: code, company_name: that.val }).then(res => {
        if (!res.success) {
          if (res.error_msg) {
            that.$toast.warning(res.error_msg)
          } else {
            that.$toast.warning('保存失败')
          }
          return
        }
        that.$toast.success('保存成功')
        setTimeout(function() {
          that.goBack()
        }, 1500);
      })
    }
  }
}
</script>

<style scoped>
</style>
